import React, { type FC } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';

import PageSection from 'src/components/page/PageSection';

type Props = {
    weekdayLabels: string[];
    weekCompletion: boolean[];
};

const CurrentWeekSection: FC<Props> = ({
    weekdayLabels,
    weekCompletion,
}) => {
    return (
        <PageSection variant="outlined">
            <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                <Typography fontWeight={700}>Current Week</Typography>
            </Box>

            <Box display="grid" gridTemplateColumns="repeat(7, 1fr)" gap={1}>
                {weekdayLabels.map((day, i) => {
                    const complete = weekCompletion[i];
                    return (
                        <Box key={`week-${day}-${i}`} display="flex" flexDirection="column" alignItems="center" gap={0.5}>
                            <Box
                                sx={{
                                    width: 28,
                                    height: 28,
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    border: '2px solid',
                                    borderColor: complete ? 'var(--color-primary-500)' : '#e0e0e0',
                                    bgcolor: complete ? 'var(--color-primary-500)' : 'transparent',
                                }}
                            >
                                {complete && <CheckRoundedIcon sx={{ fontSize: 16, color: 'white' }} />}
                            </Box>
                            <Typography variant="caption" fontWeight={600} color={complete ? 'var(--color-primary-500)' : 'text.secondary'}>
                                {day}
                            </Typography>
                        </Box>
                    );
                })}
            </Box>
        </PageSection>
    );
};

export default CurrentWeekSection;
